<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="datas && (!isVP)" (click)="onClick()" [class]="'fullHDx2-wxga roboto step_'+step" [class.smallerScreen]="smallerScreen">



  <!-- ********************************************************************************************************************************* -->
  <!-- * VIDEO *********************************************************************************************************************** -->
  <!-- ********************************************************************************************************************************* -->

  <div class="big_screen fullHDx2" *ngIf="!isVP && playingVideo && currentVideo">
    <div id="video" class="fullHDx2" (click)="onVideoClick()">
      <video #video autoplay [src]="base+datasName+'/videos/'+currentVideo" class="fullHDx2" (ended)="onVideoEnded($event)" [attr.loop]="loop ? 'loop' : null"></video>
    </div>
  </div>

  <!-- ********************************************************************************************************************************* -->
  <!-- * SPLASH *********************************************************************************************************************** -->
  <!-- ********************************************************************************************************************************* -->
  <div class="phase phase_splash" *ngIf="current == 'splash'">
    <!-- ********************************************************************************************************************************* -->
    <div class="big_screen fullHDx2" [style.backgroundImage]="bgImage">
      <div id="splash" class="page roboto fullHDx2">
        <div class="group">
          <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
          <div class="baseline">
            <span [innerHTML]="datas.baseline">...</span>
            <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
              <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              	<g>
              		<path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              			C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              			c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              			c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              			c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              			c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              		<path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              			c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              			c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              			c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              			c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              			c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
              	</g>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- ********************************************************************************************************************************* -->
    <div class="small_screen wxga">
      <div class="page roboto wxga" [style.backgroundColor]="espace.color">
        <span class="picto" *ngIf="espace">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          	<g>
          		<path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
          			C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
          			c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
          			c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
          			c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
          			c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
          		<path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
          			c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
          			c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
          			c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
          			c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
          			c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
          	</g>
          </svg>
        </span>
        <div class="menu">
          <a (click)="runPhase1()"><span>1</span> Conduite assistée</a>
          <a (click)="runPhase2()"><span>2</span> Conduite semi-autonome</a>
          <a (click)="runPhase3()"><span>3</span> Conduite autonome</a>
        </div>
      </div>
    </div>
    <!-- ********************************************************************************************************************************* -->
  </div>

  <!-- ********************************************************************************************************************************* -->
  <!-- * PHASE I *********************************************************************************************************************** -->
  <!-- ********************************************************************************************************************************* -->
  <div class="phase phase1" *ngIf="current == 'phase1'" [class.question_ended]="p1_questionFinie()">
    <!-- ********************************************************************************************************************************* -->
    <div class="big_screen fullHDx2">
      <div class="question_page" *ngIf="question">
        <div class="time" [innerHTML]="timeLeft"></div>
        <div class="question">
          <div class="table">
            <div class="cell" [innerHTML]="question?.question"></div>
          </div>
        </div>
        <div class="instruction">
          <span [innerHTML]="p1_getInstruction()"></span>
        </div>
        <div class="technologies">
          <ul>
            <li *ngFor="let techno of datas.phase1.technos" [class.on]="p1_isSelected(techno)" [class.correct]="p1_isCorrect(techno)">
              <a>
                <span class="picto" [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(techno.picto)"></span><br>
                <span class="title" [innerHTML]="techno.title"></span>
              </a>
              <div class="bubble" *ngIf="p1_getBubble(techno)">
                <span class="text" [innerHTML]="p1_getBubble(techno)"></span>
                <span class="picto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                </span>
              </div>
              <div class="bubble" *ngIf="!p1_getBubble(techno)">
                <span class="text" [innerHTML]="datas.phase1.msg_error0"></span>
                <span class="picto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ********************************************************************************************************************************* -->
    <div class="small_screen wxga">
      <div class="question_page" *ngIf="question">
        <div class="question">
          <div class="table">
            <div class="cell" [innerHTML]="question?.question"></div>
          </div>
        </div>
        <div class="instruction">
          <span [innerHTML]="p1_getInstruction()"></span>
        </div>
        <div class="technologies">
          <ul>
            <li *ngFor="let techno of datas.phase1.technos" [class.on]="p1_isSelected(techno)" [class.correct]="p1_isCorrect(techno)">
              <a (click)="p1_onTechno(techno)">
                <span class="picto" [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(techno.picto)"></span><br>
                <span class="title" [innerHTML]="techno.title"></span>
              </a>
              <div class="bubble" *ngIf="p1_getBubble(techno)">
                <span class="text" [innerHTML]="p1_getBubble(techno)"></span>
                <span class="picto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                </span>
              </div>
              <div class="bubble" *ngIf="!p1_getBubble(techno)">
                <span class="text" [innerHTML]="datas.phase1.msg_error0"></span>
                <span class="picto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <a class="home_btn" (click)="onRestart()"></a>
    </div>
    <!-- ********************************************************************************************************************************* -->
  </div>

  <!-- ********************************************************************************************************************************* -->
  <!-- * PHASE II ********************************************************************************************************************** -->
  <!-- ********************************************************************************************************************************* -->
  <div class="phase phase2" *ngIf="current == 'phase2'" [class.question_ended]="p2_questionFinie()">
    <!-- ********************************************************************************************************************************* -->
    <div class="big_screen fullHDx2">
      <div class="question_page" *ngIf="question && endedVideo">
        <div class="time">&#10074;&#10074;</div>
        <div class="question">
          <div class="table">
            <div class="cell" [innerHTML]="question?.question"></div>
          </div>
        </div>
        <div class="conclusion" *ngIf="p2_questionFinie()">
          <div class="table">
            <div class="cell">
              <div class="chapo" [innerHTML]="selected[0].conclusion_chapo"></div>
              <div class="text" [innerHTML]="selected[0].conclusion_text"></div>
            </div>
          </div>
        </div>
        <div class="answers">
          <ul>
            <li *ngFor="let answer of question.answers" [class.on]="p2_isSelected(answer)">
              <a>
                <span class="picto"></span><br>
                <span class="title" [innerHTML]="answer.answer"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ********************************************************************************************************************************* -->
    <div class="small_screen wxga">
      <div class="question_page" *ngIf="question && endedVideo && !p2_questionFinie()">
        <div class="bg"></div>
        <div class="question">
          <div class="table">
            <div class="cell" [innerHTML]="question?.question"></div>
          </div>
        </div>
        <div class="answers">
          <ul>
            <li *ngFor="let answer of question.answers" [class.on]="p2_isSelected(answer)">
              <a (click)="p2_onSelect(answer)">
                <span class="picto"></span><br>
                <span class="title" [innerHTML]="answer.answer"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a class="btn_screen" (click)="p2_onNext()" *ngIf="p2_questionFinie()">
        <span class="picto">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              <path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
            </g>
          </svg>
        </span>
      </a>
      <a class="home_btn" (click)="onRestart()"></a>
    </div>
    <!-- ********************************************************************************************************************************* -->
  </div>

  <!-- ********************************************************************************************************************************* -->
  <!-- * PHASE III ********************************************************************************************************************** -->
  <!-- ********************************************************************************************************************************* -->
  <div class="phase phase3" *ngIf="current == 'phase3'" [class.question_ended]="p3_fini()">
    <!-- ********************************************************************************************************************************* -->
    <div class="big_screen fullHDx2">
      <div class="dialogs_page">
        <div class="speeches">
          <div *ngFor="let speech of speeches" [class]="'speech speech_'+speech.character">
            <div class="text">
              <pre [innerHTML]="speech.text"></pre>
            </div>
          </div>
        </div>
        <div class="conclusion" *ngIf="p3_fini()">
          <div class="table">
            <div class="cell">
              <div class="chapo" [innerHTML]="selected[0].conclusion_chapo"></div>
              <div class="text" [innerHTML]="selected[0].conclusion_text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ********************************************************************************************************************************* -->
    <div class="small_screen wxga">
      <div class="answers_page" [style.backgroundImage]="bgImageTab">
        <div class="bg"></div>
        <div class="answers" *ngIf="!typing">
          <ul>
            <li *ngFor="let button of dialog?.buttons" [class.on]="p3_isSelected(button)">
              <a (click)="p3_onSelect(button)">
                <span class="text" [innerHTML]="button.button"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a class="btn_screen" (click)="p3_onNext()" *ngIf="p3_fini()">
        <span class="picto">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              <path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
            </g>
          </svg>
        </span>
      </a>
      <a class="home_btn" (click)="onRestart()"></a>
    </div>
    <!-- ********************************************************************************************************************************* -->
  </div>

  <!-- ********************************************************************************************************************************* -->
  <!-- ********************************************************************************************************************************* -->
  <!-- ********************************************************************************************************************************* -->

</div>
<div id="debug" [innerHTML]="debugTxt" *ngIf="debug"></div>
